import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export function summeryPage(certInCustomerName, certInApplicationName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text:
                    certInCustomerName +
                    " engaged ISECURION for performing Mobile Application Security Audit of their " +
                    certInApplicationName +
                    " Mobile Application.",
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}


export function summaryBulletOne(certInEndDate, certInStartDate) {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return 'th';
            else {
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            }
        }
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const formattedDate = `${date.getDate()}`;
        const ordinalSuffix = getOrdinalSuffix(date.getDate());
        const formatMonth = monthNames[date.getMonth()];
        const formatYear = date.getFullYear();

        return {
            formattedDate,
            ordinalSuffix,
            formatMonth,
            formatYear
        };
    };

    const formattedStartDate = formatDate(certInStartDate);
    const formattedEndDate = formatDate(certInEndDate);

    return new Paragraph({
        indent: { left: 600 },
        bullet: { level: 0 },
        spacing: { line: 350, after: 10 * 72 * 0.05 },
        children: [
            new TextRun({
                text: "The Stage 1 Security Audit was executed from",
                size: 22,
                font: "Calibri",
                bullet: { level: 0 },
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedStartDate.formattedDate,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),

            new TextRun({
                text: formattedStartDate.ordinalSuffix,
                superScript: true,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedStartDate.formatMonth + ' ' + formattedStartDate.formatYear + ' ',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: 'to',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formattedDate,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: formattedEndDate.ordinalSuffix,
                superScript: true,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formatMonth + ' ' + formattedEndDate.formatYear + ' ',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),

        ]
    })
}